// ONE label per action (47071): al('recordDelivery') -> the canonical EN/FR label from locales/<lg>/actions.json. Use it for every button, menu item, title and submit of that action.
import { useTranslation } from 'react-i18next';
export default function useActionLabel() {
  const { t } = useTranslation('actions');
  return (action) => t(action);
}
